export const getFileType = f => {
  const contentTypeMap = {
    // pdf
    'application/pdf': 'pdf',
    // doc
    'application/msword': 'doc',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
      'doc',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.template':
      'doc',
    // excel
    'application/excel': 'xls',
    'application/x-excel': 'xls',
    'application/x-msexcel': 'xls',
    'application/vnd.ms-excel': 'xls',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'xls',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.template':
      'xls',
    'application/vnd.ms-excel.addin.macroEnabled.12': 'xls',
    'application/vnd.ms-excel.sheet.binary.macroEnabled.12': 'xls',
    // ppt
    'application/mspowerpoint': 'ppt',
    'application/powerpoint': 'ppt',
    'application/vnd.ms-powerpoint': 'ppt',
    'application/x-mspowerpoint': 'ppt',
    'application/vnd.openxmlformats-officedocument.presentationml.template':
      'ppt',
    'application/vnd.openxmlformats-officedocument.presentationml.slideshow':
      'ppt',
    'application/vnd.openxmlformats-officedocument.presentationml.presentation':
      'ppt',
    'application/vnd.openxmlformats-officedocument.presentationml.slide': 'ppt',
    // zip
    'application/x-compressed': 'zip',
    'application/x-zip-compressed': 'zip',
    'application/zip': 'zip',
    'multipart/x-zip': 'zip',
    'application/x-gzip': 'zip',
    'application/gzip': 'zip',
    'multipart/x-gzip': 'zip',
    'application/x-rar-compressed': 'zip',
    'application/x-tar': 'zip',
    'application/x-bzip2': 'zip',
    'application/x-lzip': 'zip',
    'application/x-compress': 'zip',
    'application/x-7z-compressed': 'zip',
    'application/x-arj': 'zip',
    'application/x-gtar': 'zip',
    // xml
    'text/html': 'xml',
    'text/css': 'xml',
    'text/javascript': 'xml',
    'text/xml': 'xml',
    'application/javascript': 'xml',
    'application/json': 'xml',
    // txt
    text: 'txt',
    // music
    audio: 'audio',
    // video
    video: 'video',
    // image
    image: 'image',
  };

  let candidate = contentTypeMap[f.file.contentType];
  if (candidate !== undefined) {
    return candidate;
  }

  candidate = contentTypeMap[f.file.contentType.split('/')[0]];
  if (candidate !== undefined) {
    return candidate;
  }

  const nameLower = f.file.name.toLowerCase();
  if (/\.pdf$/.test(nameLower)) {
    return 'pdf';
  } else if (/\.ppt$/.test(nameLower)) {
    return 'ppt';
  } else if (/\.txt$/.test(nameLower)) {
    return 'txt';
  } else if (/\.xls$/.test(nameLower)) {
    return 'xls';
  } else if (/\.xml$/.test(nameLower)) {
    return 'xml';
  } else if (/\.zip$/.test(nameLower)) {
    return 'zip';
  } else {
    return 'generic';
  }
};

// return File;
